import axios from 'src/utils/axios';
import helpers from 'src/helpers';
import { NOTIFICATION_STATUS } from 'src/constants';
import { addNotification } from 'src/actions/notificationActions';

export const GET_CONTACT_CATEGORIES_LIST = '@contact-settings/get-contact-categories-list';
export const GET_CONTACT_CATEGORIES_LIST_SUCCESS = '@contact-settings/get-contact-categories-list-success';
export const GET_CONTACT_CATEGORIES_LIST_ERROR = '@contact-settings/get-contact-categories-list-error';
export const CLEAR_CONTACT_CATEGORIES_LIST = '@contact-settings/clear-contact-categories-list';

export const GET_CONTACT_CATEGORY = '@contact-settings/get-contact-category';
export const GET_CONTACT_CATEGORY_SUCCESS = '@contact-settings/get-contact-category-success';
export const GET_CONTACT_CATEGORY_ERROR = '@contact-settings/get-contact-category-error';

export const CREATE_CONTACT_CATEGORY = '@contact-settings/create-contact-category';
export const CREATE_CONTACT_CATEGORY_SUCCESS = '@contact-settings/create-contact-category-success';
export const CREATE_CONTACT_CATEGORY_ERROR = '@contact-settings/create-contact-category-error';

export const UPDATE_CONTACT_CATEGORY = '@contact-settings/update-contact-category';
export const UPDATE_CONTACT_CATEGORY_SUCCESS = '@contact-settings/update-contact-category-success';
export const UPDATE_CONTACT_CATEGORY_ERROR = '@contact-settings/update-contact-category-error';

export const CHANGE_CONTACT_CATEGORY_STATUS = '@contact-settings/change-contact-category-status';
export const CHANGE_CONTACT_CATEGORY_STATUS_SUCCESS = '@contact-settings/change-contact-category-status-success';
export const CHANGE_CONTACT_CATEGORY_STATUS_ERROR = '@contact-settings/change-contact-category-status-error';

export const DELETE_CONTACT_CATEGORY = '@contact-settings/delete-contact-category';
export const DELETE_CONTACT_CATEGORY_SUCCESS = '@contact-settings/delete-contact-category-success';
export const DELETE_CONTACT_CATEGORY_ERROR = '@contact-settings/delete-contact-category-error';
export const CLEAR_CONTACT_CATEGORY_WAS_DELETED = '@contact-settings/clear-contact-category-was-deleted';

export const REMOVE_CONTACTS_FROM_CATEGORY = '@contact-settings/remove-contacts-from-category';
export const REMOVE_CONTACTS_FROM_CATEGORY_SUCCESS = '@contact-settings/remove-contacts-from-category-success';
export const REMOVE_CONTACTS_FROM_CATEGORY_ERROR = '@contact-settings/remove-contacts-from-category-error';

export const CLEAR_CONTACT_CATEGORY_DETAILS = '@contact-settings/clear-contact-category-details';

export const SET_CURRENT_NAVIGATION_TAB = '@contact-settings/set-current-navigation-tab';
export const SET_CONTACT_CATEGORY_DETAILS_VIEW_TAB = '@contact-settings/set-contact-category-details-view-tab';
export const SET_SELECTED_CONTACT_CATEGORIES = '@contact-settings/set-selected-contact-categories';
export const SET_CONTACT_CATEGORIES_QUERY = '@contact-settings/set-contact-categories-query';
export const SET_BACK_TO_CATEGORIES_LIST = '@contact-settings/set-back-to-categories-list';

export const setCurrentNavigationTab = (tabName) => ({
  type: SET_CURRENT_NAVIGATION_TAB,
  payload: tabName
});

export const setContactCategoryDetailsViewTab = (tabName) => async (dispatch) => {
  dispatch({
    type: SET_CONTACT_CATEGORY_DETAILS_VIEW_TAB,
    payload: tabName
  });
};

export const setContactCategoriesQuery = (query) => ({
  type: SET_CONTACT_CATEGORIES_QUERY,
  payload: query
});

export const getAllCategoriesList = (isPaginationDisabled = false) => async (dispatch, getState) => {
  dispatch({
    type: GET_CONTACT_CATEGORIES_LIST,
  });
  try {
    const query = getState()?.contactSettings?.query || {};
    const params = {
      ...query,
      count: undefined,
      isPaginationDisabled,
      ...(isPaginationDisabled && { page: undefined, pageSize: undefined }),
    };
    const response = await axios.get('/api/contact-settings/category', { params });
    dispatch({
      type: GET_CONTACT_CATEGORIES_LIST_SUCCESS,
      payload: response?.data || [],
    });
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(GET_CONTACT_CATEGORIES_LIST_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: GET_CONTACT_CATEGORIES_LIST_ERROR,
    });
  }
};

export const getContactCategory = (categoryId) => async (dispatch) => {
  dispatch({
    type: GET_CONTACT_CATEGORY,
  });
  try {
    const response = await axios.get(`/api/contact-settings/category/${categoryId}`);
    dispatch({
      type: GET_CONTACT_CATEGORY_SUCCESS,
      payload: response?.data || {}
    });
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(GET_CONTACT_CATEGORY_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: GET_CONTACT_CATEGORY_ERROR,
    });
  }
};

export const createContactCategory = (payload, doWhenTry = false, doWhenCatch = false) => async (dispatch) => {
  try {
    dispatch({
      type: CREATE_CONTACT_CATEGORY,
    });
    const response = await axios.post('/api/contact-settings/category', payload);
    const {
      id,
      name,
    } = response?.data || {};

    if (!id) {
      dispatch(addNotification(CREATE_CONTACT_CATEGORY_ERROR, 'Cannot create category', NOTIFICATION_STATUS.ERROR));
      dispatch({
        type: CREATE_CONTACT_CATEGORY_ERROR,
      });
      return;
    }

    dispatch(addNotification(CREATE_CONTACT_CATEGORY_SUCCESS, `Category ${name} has been successfully created`, NOTIFICATION_STATUS.SUCCESS));
    dispatch({
      type: CREATE_CONTACT_CATEGORY_SUCCESS,
    });

    if (doWhenTry) {
      doWhenTry(id);
    }
  } catch (e) {
    const {
      message,
      error,
    } = e?.response?.data || {};
    dispatch(addNotification(CREATE_CONTACT_CATEGORY_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: CREATE_CONTACT_CATEGORY_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const updateContactCategory = (payload, doWhenTry = false, doWhenCatch = false) => async (dispatch) => {
  try {
    dispatch({
      type: UPDATE_CONTACT_CATEGORY,
    });
    const response = await axios.put('/api/contact-settings/category', payload);
    const {
      id,
    } = response?.data || {};

    dispatch(addNotification(UPDATE_CONTACT_CATEGORY_SUCCESS, 'Category has been successfully updated', NOTIFICATION_STATUS.SUCCESS));
    dispatch({
      type: UPDATE_CONTACT_CATEGORY_SUCCESS,
    });

    if (doWhenTry) {
      doWhenTry(id);
    }
  } catch (e) {
    const {
      message,
      error,
    } = e?.response?.data || {};
    dispatch(addNotification(UPDATE_CONTACT_CATEGORY_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: UPDATE_CONTACT_CATEGORY_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const changeContactCategoryStatus = (payload, doWhenTry = false, doWhenCatch = false) => async (dispatch) => {
  dispatch({
    type: CHANGE_CONTACT_CATEGORY_STATUS,
  });
  try {
    const response = await axios.patch('/api/contact-settings/category', payload);
    const isSuccess = response?.data?.success;

    if (!isSuccess) {
      dispatch(addNotification(CHANGE_CONTACT_CATEGORY_STATUS_ERROR, 'Cannot change category status', NOTIFICATION_STATUS.ERROR));
      dispatch({
        type: CHANGE_CONTACT_CATEGORY_STATUS_ERROR,
      });
      return;
    }

    const categoryText = payload?.ids?.length === 1 ? 'Category status has' : 'Category statuses have';
    dispatch(addNotification(CHANGE_CONTACT_CATEGORY_STATUS_SUCCESS, `${categoryText} been successfully changed`, NOTIFICATION_STATUS.SUCCESS));
    dispatch({
      type: CHANGE_CONTACT_CATEGORY_STATUS_SUCCESS,
    });

    if (doWhenTry) {
      doWhenTry();
    }
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(CHANGE_CONTACT_CATEGORY_STATUS_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: CHANGE_CONTACT_CATEGORY_STATUS_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const deleteContactCategory = (categoryIds = [], cancelRedirectToCategoriesList = false, doWhenTry = false, doWhenCatch = false) => async (dispatch) => {
  dispatch({
    type: DELETE_CONTACT_CATEGORY,
  });
  try {
    const response = await axios.delete('/api/contact-settings/category', {
      data: { ids: categoryIds },
    });
    const isSuccess = response?.data?.success;

    if (!isSuccess) {
      dispatch(addNotification(DELETE_CONTACT_CATEGORY_ERROR, 'Cannot delete category', NOTIFICATION_STATUS.ERROR));
      dispatch({
        type: DELETE_CONTACT_CATEGORY_ERROR,
      });
      return;
    }

    dispatch(addNotification(DELETE_CONTACT_CATEGORY_SUCCESS, 'Category has been successfully deleted', NOTIFICATION_STATUS.SUCCESS));
    dispatch({
      type: DELETE_CONTACT_CATEGORY_SUCCESS,
      payload: { cancelRedirectToCategoriesList },
    });
    // Removed getAccountInfo() — it triggered 15-20 sequential DB queries
    // just to refresh account data that doesn't change on category delete.
    // The doWhenTry callback (from the list view) calls getAllCategoriesList()
    // which is sufficient to refresh the category list.

    if (doWhenTry) {
      doWhenTry();
    }
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(DELETE_CONTACT_CATEGORY_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: DELETE_CONTACT_CATEGORY_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const clearContactCategoriesList = () => async (dispatch) => {
  dispatch({
    type: CLEAR_CONTACT_CATEGORIES_LIST,
  });
};

export const clearContactCategoryWasDeleted = () => async (dispatch) => {
  dispatch({
    type: CLEAR_CONTACT_CATEGORY_WAS_DELETED,
  });
};

export const clearContactCategoryDetails = () => async (dispatch) => {
  dispatch({
    type: CLEAR_CONTACT_CATEGORY_DETAILS,
  });
};

export const setBackToCategoriesList = (payload) => ({
  type: SET_BACK_TO_CATEGORIES_LIST,
  payload,
});

export const clearBackToCategoriesList = (clearAll = false) => ({
  type: SET_BACK_TO_CATEGORIES_LIST,
  payload: !clearAll ? {
    categories: [],
    query: {},
  } : false,
});

export const setSelectedContactCategories = (selectedContactCategories) => ({
  type: SET_SELECTED_CONTACT_CATEGORIES,
  payload: selectedContactCategories
});

export const removeContactsFromCategory = (categoryId, contactIds, doWhenTry = false, doWhenCatch = false) => async (dispatch) => {
  dispatch({
    type: REMOVE_CONTACTS_FROM_CATEGORY,
  });
  try {
    const response = await axios.delete(`/api/contacts/category/by-id/${categoryId}`, {
      data: { contactIds },
    });
    const isSuccess = response?.data?.success;

    if (!isSuccess) {
      dispatch(addNotification(REMOVE_CONTACTS_FROM_CATEGORY_ERROR, 'Cannot remove contacts from category', NOTIFICATION_STATUS.ERROR));
      dispatch({
        type: REMOVE_CONTACTS_FROM_CATEGORY_ERROR,
      });
      return;
    }

    const contactText = contactIds?.length === 1 ? 'Contact has' : 'Contacts have';
    dispatch(addNotification(REMOVE_CONTACTS_FROM_CATEGORY_SUCCESS, `${contactText} been successfully removed from category`, NOTIFICATION_STATUS.SUCCESS));
    dispatch({
      type: REMOVE_CONTACTS_FROM_CATEGORY_SUCCESS,
    });

    if (doWhenTry) {
      doWhenTry();
    }
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(REMOVE_CONTACTS_FROM_CATEGORY_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: REMOVE_CONTACTS_FROM_CATEGORY_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const removeContactsFromCategoryByName = (categoryName, contactIds, doWhenTry = false, doWhenCatch = false) => async (dispatch) => {
  dispatch({
    type: REMOVE_CONTACTS_FROM_CATEGORY,
  });
  try {
    // Backend enforces a 1,000-contact limit per request.
    // Batch into chunks of 1,000 to support bulk selections of 2,500-5,000.
    const CHUNK_SIZE = 1000;
    const ids = contactIds || [];
    for (let i = 0; i < ids.length; i += CHUNK_SIZE) {
      const chunk = ids.slice(i, i + CHUNK_SIZE);
      // eslint-disable-next-line no-await-in-loop
      const response = await axios.delete(`/api/contacts/category/by-id/${encodeURIComponent(categoryName)}`, {
        data: {
          contactIds: chunk,
          categoryName: true,
        },
      });
      const isSuccess = response?.data?.success;

      if (!isSuccess) {
        dispatch(addNotification(REMOVE_CONTACTS_FROM_CATEGORY_ERROR, 'Cannot remove contacts from category', NOTIFICATION_STATUS.ERROR));
        dispatch({
          type: REMOVE_CONTACTS_FROM_CATEGORY_ERROR,
        });
        return;
      }
    }

    const contactText = ids.length === 1 ? 'Contact has' : 'Contacts have';
    dispatch(addNotification(REMOVE_CONTACTS_FROM_CATEGORY_SUCCESS, `${contactText} been successfully removed from category`, NOTIFICATION_STATUS.SUCCESS));
    dispatch({
      type: REMOVE_CONTACTS_FROM_CATEGORY_SUCCESS,
    });

    if (doWhenTry) {
      doWhenTry();
    }
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(REMOVE_CONTACTS_FROM_CATEGORY_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: REMOVE_CONTACTS_FROM_CATEGORY_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};
